import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { t } from "@wr/i18n";
import { App } from "./App";
import { installAnalytics } from "./lib/analytics";
import "./index.css";

// index.html carries the same literal for first paint / no-JS; the catalogue is
// the source of truth once React is up (architecture §14 rule 10).
document.title = t("app.name");

// Site-usage analytics (§16g A79, T-263). A no-op unless the build carries a
// website id, which production does not today. Called before render and outside
// React so it cannot be double-invoked by StrictMode, and after `document.title`
// because the tracker sends the title with the first page view.
installAnalytics();

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
